import { BaseIcon } from '@cof/plastic-components';

const extendBaseIcon = (svg) => (props) => <BaseIcon IconSvg={svg} {...props} />;
export default extendBaseIcon;
